import { profile } from '../data/profile'

const Footer = () => {
  return (
    <footer className="section-shell py-10">
      <div className="flex flex-col justify-between gap-5 border-t border-academic-line pt-8 text-sm text-academic-muted md:flex-row md:items-center">
        <div>
          <p className="font-semibold text-academic-text">{profile.name}</p>
          <p className="mt-1">Clean academic portfolio for graduate admissions.</p>
        </div>
        <div className="flex gap-5">
          <a href={profile.github} className="transition hover:text-academic-blue">GitHub</a>
          <a href={profile.linkedin} className="transition hover:text-academic-blue">LinkedIn</a>
          <a href={`mailto:${profile.email}`} className="transition hover:text-academic-blue">Email</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
